import * as z from "@-/com.npmjs.zod";

export const morphemePinyinMorphemeSliceSchema = z.object({
  gloss: z.string().nullish(),
  mnemonic: z.string().nullish(),
});
